import React, { useContext } from 'react';
import { Collapse, Input, Button, Form, message, Card, Typography, Divider } from 'antd';
import {
  QuestionCircleOutlined,
  SendOutlined,
  MailOutlined,
  FileTextOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import axios from 'axios';
import AppLayout from "./components/UserDashboardLayout";
import { LanguageContext } from "./LanguageContext";
import { locales } from './language';

const { Panel } = Collapse;
const { TextArea } = Input;
const { Title, Text } = Typography;

const Support = () => {
  const [form] = Form.useForm();
  const { language } = useContext(LanguageContext);
  const t = locales[language];

  const handleSubmit = async (values) => {
    try {
      await axios.post('https://json-configrator-api.root.myoctoopidev.com/Support/Create', {
        title: values.title,
        description: values.description,
        email: values.email,
      });
      message.success(t.successMessage || 'Yardım talebiniz başarıyla gönderildi!');
      form.resetFields();
    } catch (error) {
      console.error('Yardım talebi gönderilemedi:', error);
      message.error(t.errorMessage || 'Bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  const panels = [
    { key: '1', header: t.sae,     content: t.sefeat   },
    { key: '2', header: t.icc,     content: t.bepy      },
    { key: '3', header: t.p3Header, content: t.p3Content },
    { key: '4', header: t.p4Header, content: t.p4Content },
    { key: '5', header: t.p5Header, content: t.p5Content },
    { key: '6', header: t.p6Header, content: t.p6Content },
    { key: '7', header: t.p7Header, content: t.p7Content },
    { key: '8', header: t.p8Header, content: t.p8Content },
    { key: '9', header: t.p9Header, content: t.p9Content },
  ];

  return (
    <AppLayout>
      <div style={{ padding: 20 }}>

        {/* Nasıl Kullanılır */}
        <Card
          style={{ borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', border: 'none', marginBottom: 20 }}
          bodyStyle={{ padding: 28 }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
            <div style={{
              width: 40, height: 40, borderRadius: '50%',
              background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(24,144,255,0.25)',
            }}>
              <QuestionCircleOutlined style={{ fontSize: 18, color: '#fff' }} />
            </div>
            <div>
              <Title level={4} style={{ margin: 0, fontWeight: 700, color: '#262626' }}>
                {t.nk}
              </Title>
              <Text style={{ color: '#8c8c8c', fontSize: 13 }}>
                {panels.length} {language === 'tr' ? 'bölüm' : 'section'}
              </Text>
            </div>
          </div>

          <Divider style={{ margin: '0 0 20px' }} />

          <Collapse
            accordion
            expandIconPosition="end"
            style={{ borderRadius: 8, overflow: 'hidden' }}
          >
            {panels.map((p) => (
              <Panel
                key={p.key}
                header={
                  <span style={{ fontWeight: 600, color: '#262626', fontSize: 14 }}>
                    {p.header}
                  </span>
                }
                style={{ borderBottom: '1px solid #f0f0f0' }}
              >
                <p
                  style={{ color: '#595959', lineHeight: 1.7, margin: 0, fontSize: 14 }}
                  dangerouslySetInnerHTML={{ __html: p.content }}
                />
              </Panel>
            ))}
          </Collapse>
        </Card>

        {/* Yardım Talebi */}
        <Card
          style={{ borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', border: 'none' }}
          bodyStyle={{ padding: 28 }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
            <div style={{
              width: 40, height: 40, borderRadius: '50%',
              background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(82,196,26,0.25)',
            }}>
              <MessageOutlined style={{ fontSize: 18, color: '#fff' }} />
            </div>
            <div>
              <Title level={4} style={{ margin: 0, fontWeight: 700, color: '#262626' }}>
                {t.ytb}
              </Title>
              <Text style={{ color: '#8c8c8c', fontSize: 13 }}>
                {t.mail}
              </Text>
            </div>
          </div>

          <Divider style={{ margin: '0 0 24px' }} />

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            style={{ maxWidth: 600 }}
          >
            <Form.Item
              label={<span style={{ fontWeight: 500 }}>{t.titlee}</span>}
              name="title"
              rules={[{ required: true, message: t.titleRequired || 'Başlık alanı zorunludur!' }]}
            >
              <Input
                prefix={<FileTextOutlined style={{ color: '#bfbfbf' }} />}
                placeholder={t.titlee}
                style={{ borderRadius: 8, height: 40 }}
              />
            </Form.Item>

            <Form.Item
              label={<span style={{ fontWeight: 500 }}>{t.mail}</span>}
              name="email"
              rules={[{ required: true, message: t.mailRequired || 'E-Mail alanı zorunludur!' }]}
            >
              <Input
                prefix={<MailOutlined style={{ color: '#bfbfbf' }} />}
                placeholder={t.mail}
                style={{ borderRadius: 8, height: 40 }}
              />
            </Form.Item>

            <Form.Item
              label={<span style={{ fontWeight: 500 }}>{t.description}</span>}
              name="description"
              rules={[{ required: true, message: t.descriptionRequired || 'Açıklama alanı zorunludur!' }]}
            >
              <TextArea
                rows={4}
                placeholder={t.description}
                style={{ borderRadius: 8 }}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                icon={<SendOutlined />}
                style={{
                  height: 40,
                  borderRadius: 8,
                  background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                  border: 'none',
                  fontWeight: 600,
                  boxShadow: '0 4px 12px rgba(82,196,26,0.35)',
                }}
              >
                {t.tb}
              </Button>
            </Form.Item>
          </Form>
        </Card>

      </div>
    </AppLayout>
  );
};

export default Support;
